export enum AuthStatusCode {
  FORBIDDEN = "FORBIDDEN",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  INVALID_PARAMATER = "INVALID_PARAMATER",
  LOGGED_IN = "LOGGED_IN",
  NETWORK_UNAVAILABLE = "NETWORK_UNAVAILABLE",
  NONE = "NONE",
  TWO_FACTOR_REQUIRED = "TWO_FACTOR_REQUIRED",
  THIRD_PARTY_ERROR = "THIRD_PARTY_ERROR",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  USER_ALREADY_EXIST = "USER_ALREADY_EXIST",
  ABORTED_BY_USER = "ABORTED_BY_USER",
  RATE_LIMIT = "RATE_LIMIT",

  // extra codes
  LAST_BOARD_ADMIN_REMOVAL = "LAST_BOARD_ADMIN_REMOVAL",
  LAST_GROCERY_BOARD_MEMBER_REMOVAL = "LAST_GROCERY_BOARD_MEMBER_REMOVAL",
  LAST_SPACE_ADMIN_REMOVAL = "LAST_SPACE_ADMIN_REMOVAL",
  CANT_DELETE_PREMIUM_USER = "CANT_DELETE_PREMIUM_USER",
}
